import { digObject } from '@domain-group/javascript-utils'

import { DashboardModule, HalfPieChart } from '@domain-group/suit-theme'

import useAgency from '@hooks/useAgency'

import formatServiceBreakdown from '@functions/formatServiceBreakdown'

const ServiceBreakdown = (props: { agencyId: number }) => {
  const { agencyId } = props

  const { agency } = useAgency({ id: agencyId })

  const { provider_metrics } = agency || {}
  const breakdowns = digObject(provider_metrics, 'metrics.orders.services.breakdowns', [])

  const data = formatServiceBreakdown(breakdowns)
  const { formattedServiceBreakdown, formattedThemes } = data

  return (
    <DashboardModule title="Service Breakdown">
      <HalfPieChart
        width="100%"
        height={200}
        hideGaps
        // @ts-expect-error TS2741
        dataPayload={{
          dataArray: formattedServiceBreakdown,
          theme: formattedThemes,
        }}
      />
    </DashboardModule>
  )
}

export default ServiceBreakdown
